import React from "react"
import { Box, Flex, SimpleGrid, Text, Button } from "@chakra-ui/react"
import { AccuraLogoImg, DrillCutLogoImg, DrillFastLogoImg, powagroupLogoImg } from "../images"
import { Paths, componentMinHeight } from "../../common/commonConstants"
import { DistributorCard, type DistributersInterface } from "./distributorCard"
import { useNavigate } from "react-router"

export const PurchaseInformation = (): JSX.Element => {
  const navigate = useNavigate()
  const navigateTo = (link: string): void => {
    navigate(link)
  }
  const distributors: DistributersInterface[] = [
    {
      title: "ACT",
      logo: powagroupLogoImg,
      logoW: "184px",
      logoH: "49px",
      website: "powagroup.com.au",
      email: "sales@powagroup.com.au",
      phone: "(02) 1300 303 366"
    },
    {
      title: "NSW",
      logo: DrillCutLogoImg,
      logoW: "186px",
      logoH: "36px",
      website: "drillcut.au",
      email: "sales@drillcut.com.au",
      phone: "(02) 9737 0099"
    },
    {
      title: "NT",
      logo: AccuraLogoImg,
      logoW: "159px",
      logoH: "47px",
      website: "acuragroup.com.au",
      email: "sales@acuragroup.com.au",
      phone: "(08) 1300 750 750"
    },
    {
      title: "QLD",
      logo: DrillFastLogoImg,
      logoW: "188px",
      logoH: "42px",
      website: "drillfast.com.au",
      email: "sales@drillfast.com.au",
      phone: "(07) 1300 923 414"
    },
    {
      title: "SA",
      logo: AccuraLogoImg,
      logoW: "159px",
      logoH: "47px",
      website: "acuragroup.com.au",
      email: "sales@acuragroup.com.au",
      phone: "(08) 1300 750 750"
    },
    {
      title: "TAS",
      logo: DrillCutLogoImg,
      logoW: "186px",
      logoH: "36px",
      website: "drillcut.au",
      email: "sales@drillcut.com.au",
      phone: "(03) 6272 1190"
    },
    {
      title: "VIC",
      logo: DrillCutLogoImg,
      logoW: "186px",
      logoH: "36px",
      website: "drillcut.au",
      email: "sales@drillcut.com.au",
      phone: "(03) 8301 9999"
    },
    {
      title: "WA",
      logo: AccuraLogoImg,
      logoW: "159px",
      logoH: "47px",
      website: "acuragroup.com.au",
      email: "sales@acuragroup.com.au",
      phone: "(08) 1300 750 750"
    }
  ]

  return (
    <Box minH={componentMinHeight}>
      <Text variant={["RBody", "RBody", "Body1Regular"]} margin={"auto"} align={"center"} paddingY={"24px"}>
        Please contact your local distributor for purchase inquiries or contact us
        <Button
          variant="linkButtonBig"
          fontSize={"16px"}
          bottom="2px"
          onClick={() => {
            navigateTo(Paths.DISTRIBUTORS)
          }}
        >
          here
        </Button>
        .
      </Text>
      <SimpleGrid columns={[1, 2, 4]} spacing={10} mb="58px" margin="auto">
        {distributors.map(item => (
          <Flex align={"center"} justify={["center", "center", "center", "initial", "initial", "initial"]} key={item?.title}>
            <DistributorCard options={item} />
          </Flex>
        ))}
      </SimpleGrid>
    </Box>
  )
}
